import type { Pattern } from "src/types";
import styled, { css } from "styled-components";

import { withViewportStyle } from "../with-viewport-style";

interface Props {
  as?: React.ElementType | string;
  pattern: Pattern;
}

const TYPES_MAP: Partial<Record<Pattern, string>> = {
  headingOne: "h1",
  headingTwo: "h2",
  headingThree: "h3",
  headingFour: "h4",
};

const InternalTypography = styled.p.attrs<Props>((props) => ({
  as: props.as || TYPES_MAP[props.pattern] || "p",
}))``;

const getStyles = (props) => (styles: Record<string, any>) => {
  const { color, ...otherStyles } = styles;

  return {
    ...otherStyles,
    ...(color && props.theme.colors[color]
      ? { color: props.theme.colors[color] }
      : {}),
  };
};

export const Typography = withViewportStyle(InternalTypography)<Props>`
    ${({ theme, $viewport, pattern }) => {
      const patternConfig = theme.typography?.patterns?.[pattern];

      if (!patternConfig) {
        return null;
      }

      const { viewport: viewportStyles, ...styles } = patternConfig;

      const baseStyles = css`
        font-family: ${theme.fontImports[0]?.font?.name ??
        theme.fonts[0].value};
        ${(props) => getStyles(props)(styles)}
      `;

      if (!viewportStyles) {
        return baseStyles;
      }

      return css`
        ${baseStyles}
        ${viewportStyles.tablet &&
        $viewport.tablet((props) => getStyles(props)(viewportStyles.tablet))}

        ${viewportStyles.mobile &&
        $viewport.mobile((props) => getStyles(props)(viewportStyles.mobile))}
      `;
    }}
`;
